/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import { getClassCodes } from '../api';
import { ApiDataResponse } from '../api/types/response';

export const codes$ = createStore<string[]>([]);

const helper = createApi(codes$, {
  // @ts-ignore
  get: (state, { result }) => {
    if (result && result.success) {
      return result.result ?? [];
    }

    return state;
  },
});

export const classCodesApi = {
  get: createEffect<{}, ApiDataResponse<string[]>, {}>().use(getClassCodes),
};

sample({
  clock: classCodesApi.get.done,
  target: helper.get,
});
